import AllMatchesWrapper from '@/modules/league/new-components/change-scores-components/AllMatchesWrapper';
import { useSession } from '@/lib/SessionProvider';
import { useGetCompletedMatches } from '@/app/(default)/(leagues)/leagues/[slug]/session/[sessionId]/matchdate/[matchDateId]/queries';
import Loader from '@pickleballinc/features/src/Loader/Loader';
import { notFound } from 'next/navigation';
import { GameDayInfo } from '@/modules/league/new-components/types';

export default function LeagueChangeScoresPage({
  params,
  headerContent,
  isAuthorized,
}: {
  params: { slug: string; sessionId: string; matchDateId: string };
  headerContent: GameDayInfo;
  isAuthorized: boolean;
}) {
  const userSession = useSession();
  const { data, isLoading } = useGetCompletedMatches(params.matchDateId, isAuthorized);

  if (isLoading) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <Loader backgroundColor='bg-leagues-300/90' />
      </div>
    );
  }

  if (!data) {
    return notFound();
  }

  return (
    data && (
      <AllMatchesWrapper
        headerContent={headerContent}
        completedMatches={data.completedMatches}
        params={params}
        user={userSession?.session?.user}
        isAuthorized={isAuthorized}
      />
    )
  );
}
